import React from 'react';

export interface WfSvgProps {
  className?: string;
  style?: React.CSSProperties;
  onClick?: (e: React.MouseEvent<SVGElement>) => void;
}

export const ArrowSvg: React.FC<WfSvgProps> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={24} height={24} {...props}>
    <defs>
      <path id="arrow_svg__a" d="m15.824 4.347-6.712 6.701-6.71-6.701-1.41 1.41 8.12 8.121 8.122-8.121z" />
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(-992 -278)">
      <path fill="#FFF" d="M0 0h1440v1229H0z" />
      <rect width={658} height={46} x={375} y={267} fill="#FFF" stroke="#8B8B8B" strokeWidth={2} rx={4} />
      <use xlinkHref="#arrow_svg__a" fill="#202830" fillRule="nonzero" transform="translate(995.074 281.344)" />
    </g>
  </svg>
);

export const CalendarSvg: React.FC<WfSvgProps> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="#202830"
      d="M5 22q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 20V6q0-.824.587-1.412A1.93 1.93 0 0 1 5 4h1V2h2v2h8V2h2v2h1q.824 0 1.413.588Q21 5.175 21 6v14q0 .824-.587 1.413A1.93 1.93 0 0 1 19 22zm0-2h14V10H5z"
    />
  </svg>
);

export const CheckSvg: React.FC<WfSvgProps> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={20} height={20} {...props}>
    <defs>
      <path id="check_svg__a" d="m4.667 8.833-3.5-3.5L0 6.5l4.667 4.667 10-10L13.5 0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <use xlinkHref="#check_svg__a" fill="#FFF" fillRule="nonzero" transform="translate(3 5)" />
    </g>
  </svg>
);

export const ClearSvg: React.FC<WfSvgProps> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={24} height={24} {...props}>
    <defs>
      <path
        id="clear_svg__a"
        d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
      />
    </defs>
    <use xlinkHref="#clear_svg__a" fill="#202830" fillRule="nonzero" />
  </svg>
);

export const ErrorSvg: React.FC<WfSvgProps> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={14} height={14} {...props}>
    <defs>
      <path
        id="error_svg__a"
        d="M7.333 10h1.334v1.333H7.333zm0-5.333h1.334v4H7.333zm.66-3.334A6.663 6.663 0 0 0 1.333 8c0 3.68 2.98 6.667 6.66 6.667A6.67 6.67 0 0 0 14.667 8a6.67 6.67 0 0 0-6.674-6.667m.007 12A5.33 5.33 0 0 1 2.667 8 5.33 5.33 0 0 1 8 2.667 5.33 5.33 0 0 1 13.333 8 5.33 5.33 0 0 1 8 13.333"
      />
    </defs>
    <use xlinkHref="#error_svg__a" fill="#DB362A" fillRule="nonzero" transform="translate(-1 -1)" />
  </svg>
);

export const InfoSvg: React.FC<WfSvgProps> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={20} height={20} {...props}>
    <defs>
      <path
        id="info_svg__a"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-6h2zm0-8h-2V7h2z"
      />
    </defs>
    <use xlinkHref="#info_svg__a" fill="#FFF" fillRule="nonzero" transform="translate(-2 -2)" />
  </svg>
);

export const LoadingLargeSvg: React.FC<WfSvgProps> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={64} height={64} {...props}>
    <g fill="none" fillRule="nonzero">
      <path
        fill="#eaeaea"
        d="M32 64c17.673 0 32-14.327 32-32S49.673 0 32 0 0 14.327 0 32s14.327 32 32 32m0-3C15.984 61 3 48.016 3 32S15.984 3 32 3s29 12.984 29 29-12.984 29-29 29"
      />
      <path
        fill="#333"
        d="M32 64c17.673 0 32-14.327 32-32A31.9 31.9 0 0 0 53.917 8.683l-1.902 2.302C57.758 16.553 61 24.172 61 32c0 15.966-12.361 28.663-29 29z"
      />
    </g>
  </svg>
);

export const LoadingSvg: React.FC<WfSvgProps> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} {...props}>
    <g fill="none" fillRule="nonzero">
      <path
        fill="#eaeaea"
        d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16m0-3C8.82 29 3 23.18 3 16S8.82 3 16 3s13 5.82 13 13-5.82 13-13 13"
      />
      <path
        fill="#333"
        d="M16 32c8.837 0 16-7.163 16-16 0-4.473-1.847-8.654-5.042-11.658l-2.076 2.165C27.455 9.114 29.236 12.627 29 16c-.533 7.606-5 12.44-13 13z"
      />
    </g>
  </svg>
);

export const NetworkErrorSvg: React.FC<WfSvgProps> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={80} height={80} {...props}>
    <g fill="#AEB3B8" fillRule="nonzero">
      <path d="M75.058 28.719c-37.344-32.735-68.922-1.39-70.329 0-1.736-1.67-1.736-1.67-3.937-3.89.281-.423 36.64-36.485 78.047-.282-2.13 2.311-2.13 2.311-3.781 4.172" />
      <path d="M62.245 39.062c-25.36-20.39-45.453.766-46.266 1.72-1.878-1.72-1.878-1.72-4.078-3.61.282-.281 25.688-27.188 55.86-.703q-.394.508-2.28 2.593-1.258-.325-3.236 0m-23.25 2.407c4.016-.172 7.938.937 11.672 3.281-1.313 1.36-2.047 2.445-2.906 4.148-2.688-1.625-5.735-1.96-8.5-1.882q-7.015.14-12.22 4.234l-3.358-3.469q5.764-5.89 15.312-6.312m.828 14.843c1.469 0 2.938.594 3.969 1.625a5.55 5.55 0 0 1 1.64 3.922 5.55 5.55 0 0 1-1.64 3.922 5.7 5.7 0 0 1-3.969 1.625c-1.469 0-2.937-.594-3.969-1.625a5.55 5.55 0 0 1-1.64-3.922 5.55 5.55 0 0 1 1.64-3.922 5.7 5.7 0 0 1 3.97-1.625m24.844-12.484c-7.656 0-13.875 6.203-13.875 13.86s6.219 13.874 13.875 13.874 13.875-6.203 13.875-13.859-6.203-13.875-13.875-13.875m7.094 17.203-3.766 3.766-3.344-3.344-3.343 3.344-3.766-3.766 3.344-3.344-3.344-3.343 3.766-3.766 3.343 3.344 3.344-3.344 3.766 3.766-3.344 3.343z" />
    </g>
  </svg>
);

export const RefreshSvg: React.FC<WfSvgProps> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={22} height={16} {...props}>
    <defs>
      <path
        id="refresh_svg__a"
        d="m19 8-4 4h3c0 3.31-2.69 6-6 6a5.9 5.9 0 0 1-2.8-.7l-1.46 1.46A7.93 7.93 0 0 0 12 20c4.42 0 8-3.58 8-8h3zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46A7.93 7.93 0 0 0 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4z"
      />
    </defs>
    <use xlinkHref="#refresh_svg__a" fill="#666" fillRule="nonzero" transform="translate(-1 -4)" />
  </svg>
);

export const UnavailableErrorSvg: React.FC<WfSvgProps> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={80} height={80} {...props}>
    <g fill="#AEB3B8" fillRule="evenodd">
      <path
        fillRule="nonzero"
        d="M40 80C18 80 0 62 0 40S18 0 40 0s40 18 40 40-18 40-40 40m0-74.286C21.143 5.714 5.714 21.143 5.714 40S21.143 74.286 40 74.286 74.286 58.857 74.286 40 58.857 5.714 40 5.714"
      />
      <path d="M30 27.333a6.667 6.667 0 1 1-13.333 0 6.667 6.667 0 0 1 13.333 0M56.667 20.667a6.667 6.667 0 1 1 0 13.333 6.667 6.667 0 0 1 0-13.333" />
      <path
        fillRule="nonzero"
        d="M20.444 59.667h5.715c0-7.683 6.428-13.969 14.285-13.969S54.73 51.984 54.73 59.667h5.714c0-10.756-9-19.556-20-19.556s-20 8.8-20 19.556"
      />
    </g>
  </svg>
);
